import React, { ReactNode } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  legend?: ReactNode;
  className?: string;
  children: ReactNode;
}

const ChartCard = ({
  title,
  subtitle,
  legend,
  className = '',
  children,
}: ChartCardProps) => (
  <section
    className={`bg-secondaryBlack rounded-2xl p-5 flex flex-col gap-4 min-w-0 ${className}`}
  >
    <header className="flex flex-col gap-1">
      <h2 className="text-mainWhite text-lg font-semibold">{title}</h2>
      {subtitle && <p className="text-textGray text-sm">{subtitle}</p>}
    </header>
    {legend}
    {children}
  </section>
);

export default ChartCard;
